import { render, staticRenderFns } from "./QScoreCardSummitStartedPeriodic.vue?vue&type=template&id=00332cee&scoped=true&"
import script from "./QScoreCardSummitStartedPeriodic.vue?vue&type=script&lang=js&"
export * from "./QScoreCardSummitStartedPeriodic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00332cee",
  null
  
)

export default component.exports